
import {map} from 'rxjs/operators';
import { environment } from '../../environments/environment';
import 'rxjs/Rx';
import { AuthenticationService } from './authentication.service';


import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpHeaders, HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';



export class  Baseservice {

   protected url: string = environment.iCBMSWebApi.url;
    headers: Headers;
    http: HttpClient;
    auth;
    protected workflowApiUrl: string = environment.workflowApi.url;
    constructor(rsc: string, http: HttpClient, public authentication: AuthenticationService) {
        this.url = this.url.concat(rsc);
        this.http = http;
        this.headers = new Headers({ 'Authorization': `Bearer ${authentication.token}`, 'Content-Type': 'application/json;charset=utf-8' });
        this.workflowApiUrl = this.workflowApiUrl.concat(rsc);
        this.auth = authentication;
    }

    getAll() {
        return this.getRequest(this.url);
    }

    getById(id: any) {
        return this.getRequest(this.url + '/' + id);
    }
    getPermitById(id: any) {
      return this.getRequest(this.url + '/permit-doc-list/' + id);
  }


    protected getRequest(url: string) {
      return this.http.get(url);
    }

    add(body: any) {
        return this.http.post(this.url, body);
    }

    delete(id: number) {
      return this.http.delete(this.url + '/' + id);
    }

    update(body: any= []) {
        return this.http.put(this.url, body);
    }
  checkByCode(code: string) {
    return this.getRequest(this.url + '/check/' + code);
  }  

}
